import Content from '@/features/pos/components/OrderFinalization/Content'
import Form from '@/features/pos/components/OrderFinalization/form/Provider'
import { useEditingCartItemModal } from '@/features/pos/components/OrderFinalization/hooks/editing-cart-item-modal/useEditingCartItemModal'
import { useDeliveryPaymentMappings } from '@/features/pos/components/OrderFinalization/hooks/useDeliveryPaymentMappings'
import { useStopCartItemEditationOnUnfocus } from '@/features/pos/components/OrderFinalization/hooks/useStopCartItemEditationOnUnfocus'
import { Provider } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/contexts/Portal'
import { Provider as NoteFieldModalPortalProvider } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/NoteField/contexts/Portal'
import { usePosMode } from '@/features/pos/contexts/PosMode'
import DismissOverlayProvider from '@/features/ui/components/Dropdown/contexts/DismissOverlay'
import { useScreenLayout } from '@/hooks/screen'
import { FC, Fragment, useMemo } from 'react'

interface OrderFinalizationType extends FC {
    BottomSheetPortal: typeof Provider
}

const OrderFinalization: OrderFinalizationType = () => {
    const mode = usePosMode()

    const deliveryPaymentMappings = useDeliveryPaymentMappings()

    const layout = useScreenLayout()

    const DismissOverlayWrapper = useMemo(
        () => (layout === 'extended' ? DismissOverlayProvider : Fragment),
        [layout]
    )

    useEditingCartItemModal()
    useStopCartItemEditationOnUnfocus()

    return (
        <Form
            posMode={mode}
            defaultDeliveryTypeCategory={deliveryPaymentMappings[0]?.deliveryTypeCategory}
        >
            <NoteFieldModalPortalProvider>
                <DismissOverlayWrapper>
                    <Content deliveryPaymentMappings={deliveryPaymentMappings} />
                </DismissOverlayWrapper>
            </NoteFieldModalPortalProvider>
        </Form>
    )
}

OrderFinalization.BottomSheetPortal = Provider

export default OrderFinalization
